<template>
  <b-modal
    v-model="modalShow"
    @hidden="$emit('hidden')"
    size="xl"
  >
    <template #modal-header="{ close }">
      <div class="d-flex align-items-center flex-fill">
        <h5 class="mb-0">Relatório de Beneficio</h5>

        <b-button class="ml-auto" size="sm" variant="link" @click="close()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </b-button>
      </div>
    </template>

    <template #default>
      <div class="row" id="benefit-report">
        <!-- <pre>{{ JSON.stringify(benefitLogs) }}</pre> -->

        <div class="col-md-12" v-if="isLoading">
          <div class="d-flex align-items-center my-3">
            <b-spinner small class="mr-2"></b-spinner>
            <span>Carregando dados...</span>
          </div>
        </div>
        <div class="col-md-12" v-if="benefitLogs && benefitLogs.name">
          <h5>Cálculo Usado:</h5>
          <p>{{ benefitLogs.name }}</p>
        </div>
        <div class="col-md-12 my-2" v-if="benefitLogs.isAutoDiscart">
          <div v-if="!(benefitLogs.removedSalaries && benefitLogs.removedSalaries.length)">
            <button class="btn btn-primary" disabled>
              Ver Descarte Automatico
            </button>
            <p class="text-muted small mt-1 mb-0">
              Nenhuma contribuição pôde ser descartada neste caso — o descarte respeita os requisitos mínimos da regra.
            </p>
          </div>
          <template v-else>
          <button class="btn btn-primary" v-on:click="showRemovedSalaries = !showRemovedSalaries">
            {{ showRemovedSalaries ? 'Esconder' : 'Ver' }} Descarte Automatico
          </button>
          <button class="btn btn-primary mx-2" v-on:click="exportToXLSX(benefitLogs.removedSalaries)">
            Exportar Salários
          </button>
          <div v-if="showRemovedSalaries">
            <DualScroll class="mt-2">
              <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-nowrap">Mês</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor Utilizado</th>
                  <th class="text-nowrap">Indice de Atualização</th>
                  <th class="text-nowrap">Remuneração Atualizada</th>
                  <th class="text-nowrap">Média</th>
                  <th class="text-nowrap">Valor Final</th>
                  <th class="text-nowrap">Coeficiente</th>
                  <th class="text-nowrap">Quantidade de Salários</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in benefitLogs.removedSalaries"
                  v-bind:key="index"
                >
                  <th>
                    {{row.salary.month}}/{{row.salary.year}}
                  </th>
                  <th>
                    <span
                      v-if="row.salary && row.salary.warnings && (row.salary.warnings.includes('CONCOMITANT_SALARY') && row.salary.warnings.includes('MAX_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante e limite salarial, o valor de ambos salários foram somados e o valor foi limitado ao teto salarial"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante, o valor de ambos salários foram somados"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.salary.value)}}
                  </th>
                  <th>
                    <span
                      v-if="row.salary && row.salary.warnings && row.salary.warnings.includes('MAX_SALARY')"
                      v-b-tooltip.hover
                      title="Valor limitado ao teto previdenciário"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row.salary && row.salary.warnings && row.salary.warnings.includes('MIN_SALARY')"
                      v-b-tooltip.hover
                      title="Valor ajustado ao piso (salário mínimo)"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.salary.usedValue != null ? row.salary.usedValue : row.salary.value)}}
                  </th>
                  <th>
                    {{row.salary.update}}
                  </th>
                  <th>
                    {{formatMoney(row.salary.updatedValue)}}
                  </th>
                  <th>
                    {{ row.benefit.logs.baseContribution != null ? formatMoney(row.benefit.logs.baseContribution) : '-' }}
                  </th>
                  <th :class="{ 'text-success': isBestContribution(row.benefit.contribution, benefitLogs.bestContributionValue) }">
                    {{formatMoney(row.benefit.contribution)}}
                  </th>
                  <th>
                    {{ formatCoefficient(row.benefit.logs.percentage) }}%
                  </th>
                  <th>
                    {{row.benefit.logs.count}}
                  </th>
                </tr>
              </tbody>
              </table>
            </DualScroll>
          </div>
          </template>
        </div>
        <div
          class="col-md-12 my-2"
          v-if="hasFullAutoDiscartSimulation && benefitLogs.isAutoDiscart"
        >
          <button class="btn btn-primary" v-on:click="showFullAutoDiscartSimulation = !showFullAutoDiscartSimulation">
            {{ showFullAutoDiscartSimulation ? 'Esconder' : 'Ver' }} Simulação Completa do Descarte Automático
          </button>
          <button class="btn btn-primary mx-2" v-on:click="exportSimulationToXLSX(benefitLogs.fullAutoDiscartSimulation.removedSalaries)">
            Exportar Salários
          </button>
          <div v-if="showFullAutoDiscartSimulation">
            <DualScroll class="mt-2">
              <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-nowrap">Mês</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor Utilizado</th>
                  <th class="text-nowrap">Indice de Atualização</th>
                  <th class="text-nowrap">Remuneração Atualizada</th>
                  <th class="text-nowrap">Média</th>
                  <th class="text-nowrap">Valor Final</th>
                  <th class="text-nowrap">Coeficiente</th>
                  <th class="text-nowrap">Quantidade de Salários</th>
                  <th class="text-nowrap">Além do limite</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :class="{
                    'text-success': isBestContribution(row.benefit.contribution, benefitLogs.fullAutoDiscartSimulation.bestContributionValue) && !row.beyondAllowedDiscard,
                    'text-muted': row.beyondAllowedDiscard
                  }"
                  v-for="(row, index) in benefitLogs.fullAutoDiscartSimulation.removedSalaries"
                  v-bind:key="index"
                >
                  <th>
                    {{row.salary.month}}/{{row.salary.year}}
                  </th>
                  <th>
                    <span
                      v-if="row.salary && row.salary.warnings && (row.salary.warnings.includes('CONCOMITANT_SALARY') && row.salary.warnings.includes('MAX_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante e limite salarial, o valor de ambos salários foram somados e o valor foi limitado ao teto salarial"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante, o valor de ambos salários foram somados"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.salary.value)}}
                  </th>
                  <th>
                    <span
                      v-if="row.salary && row.salary.warnings && row.salary.warnings.includes('MAX_SALARY')"
                      v-b-tooltip.hover
                      title="Valor limitado ao teto previdenciário"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row.salary && row.salary.warnings && row.salary.warnings.includes('MIN_SALARY')"
                      v-b-tooltip.hover
                      title="Valor ajustado ao piso (salário mínimo)"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.salary.usedValue != null ? row.salary.usedValue : row.salary.value)}}
                  </th>
                  <th>
                    {{row.salary.update}}
                  </th>
                  <th>
                    {{formatMoney(row.salary.updatedValue)}}
                  </th>
                  <th>
                    {{ row.benefit.logs.baseContribution != null ? formatMoney(row.benefit.logs.baseContribution) : '-' }}
                  </th>
                  <th :class="{ 'text-success': isBestContribution(row.benefit.contribution, benefitLogs.fullAutoDiscartSimulation.bestContributionValue) && !row.beyondAllowedDiscard }">
                    <span
                      v-if="isBestContribution(row.benefit.contribution, benefitLogs.fullAutoDiscartSimulation.bestContributionValue) && !row.beyondAllowedDiscard && !benefitLogs.fullAutoDiscartSimulation.bestContributionLimitedMaxSalary"
                      v-b-tooltip.hover
                      title="O processo de Descarte Automático foi interrompido na melhor RMI."
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-if="isBestContribution(row.benefit.contribution, benefitLogs.fullAutoDiscartSimulation.bestContributionValue) && !row.beyondAllowedDiscard && benefitLogs.fullAutoDiscartSimulation.bestContributionLimitedMaxSalary"
                      v-b-tooltip.hover
                      title="O processo de Descarte Automático foi interrompido por causa do Teto Salarial."
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.benefit.contribution)}}
                  </th>
                  <th>
                    {{ formatCoefficient(row.benefit.logs.percentage) }}%
                  </th>
                  <th>
                    {{row.benefit.logs.count}}
                  </th>
                  <th>
                    <span v-if="row.beyondAllowedDiscard" class="text-muted small">
                      além do limite de descarte: {{ row.beyondReason }}
                    </span>
                  </th>
                </tr>
              </tbody>
              </table>
            </DualScroll>
          </div>
        </div>
        <div class="col-md-12 my-2" v-if="benefitLogs.salaries">
          <button class="btn btn-primary" v-on:click="showSalaries = !showSalaries">
            {{ showSalaries ? 'Esconder' : 'Ver' }} Salários
          </button>
          <button class="btn btn-primary mx-2" v-on:click="exportToXLSX(benefitLogs.salaries)">
            Exportar Salários
          </button>
          <div v-if="showSalaries">
            <DualScroll class="mt-2">
              <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-nowrap">Mês</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor Utilizado</th>
                  <th class="text-nowrap">Indice de Atualização</th>
                  <th class="text-nowrap">Remuneração Atualizada</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in benefitLogs.salaries"
                  v-bind:key="index"
                >
                  <th>
                    {{row.month}}/{{row.year}}
                  </th>
                  <th>
                    <span
                      v-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY') && row.warnings.includes('MAX_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante e limite salarial, o valor de ambos salários foram somados e o valor foi limitado ao teto salarial"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante, o valor de ambos salários foram somados"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.value)}}
                  </th>
                  <th>
                    <span
                      v-if="row && row.warnings && row.warnings.includes('MAX_SALARY')"
                      v-b-tooltip.hover
                      title="Valor limitado ao teto previdenciário"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && row.warnings.includes('MIN_SALARY')"
                      v-b-tooltip.hover
                      title="Valor ajustado ao piso (salário mínimo)"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.usedValue != null ? row.usedValue : row.value)}}
                  </th>
                  <th>
                    {{row.update}}
                  </th>
                  <th>
                    {{formatMoney(row.updatedValue)}}
                  </th>
                </tr>
              </tbody>
              </table>
            </DualScroll>
          </div>
        </div>
        <div class="col-md-12 my-2" v-if="benefitLogs.salariesSinceJul94">
          <button class="btn btn-primary" v-on:click="showJul94Salaries = !showJul94Salaries">
            {{ showJul94Salaries ? 'Esconder' : 'Ver' }} Salários Desde Julho de 94
          </button>
          <button class="btn btn-primary mx-2" v-on:click="exportToXLSX(benefitLogs.salariesSinceJul94)">
            Exportar Salários
          </button>
          <div v-if="showJul94Salaries">
            <DualScroll class="mt-2">
              <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-nowrap">Mês</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor Utilizado</th>
                  <th class="text-nowrap">Indice de Atualização</th>
                  <th class="text-nowrap">Remuneração Atualizada</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in benefitLogs.salariesSinceJul94"
                  v-bind:key="index"
                >
                  <th>
                    {{row.month}}/{{row.year}}
                  </th>
                  <th>
                    <span
                      v-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY') && row.warnings.includes('MAX_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante e limite salarial, o valor de ambos salários foram somados e o valor foi limitado ao teto salarial"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante, o valor de ambos salários foram somados"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.value)}}
                  </th>
                  <th>
                    <span
                      v-if="row && row.warnings && row.warnings.includes('MAX_SALARY')"
                      v-b-tooltip.hover
                      title="Valor limitado ao teto previdenciário"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && row.warnings.includes('MIN_SALARY')"
                      v-b-tooltip.hover
                      title="Valor ajustado ao piso (salário mínimo)"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.usedValue != null ? row.usedValue : row.value)}}
                  </th>
                  <th>
                    {{row.update}}
                  </th>
                  <th>
                    {{formatMoney(row.updatedValue)}}
                  </th>
                </tr>
              </tbody>
              </table>
            </DualScroll>
          </div>
        </div>
        <div class="col-md-12 my-2" v-if="benefitLogs.salariesSinceJul94Sorted">
          <button class="btn btn-primary" v-on:click="showJul94SalariesSorted = !showJul94SalariesSorted">
            {{ showJul94SalariesSorted ? 'Esconder' : 'Ver' }} Salários Desde Julho de 94 Ordenados por Valor
          </button>
          <div v-if="showJul94SalariesSorted">
            <DualScroll class="mt-2">
              <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-nowrap">Mês</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor Utilizado</th>
                  <th class="text-nowrap">Indice de Atualização</th>
                  <th class="text-nowrap">Remuneração Atualizada</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in benefitLogs.salariesSinceJul94Sorted"
                  v-bind:key="index"
                >
                  <th>
                    {{row.month}}/{{row.year}}
                  </th>
                  <th>
                    <span
                      v-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY') && row.warnings.includes('MAX_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante e limite salarial, o valor de ambos salários foram somados e o valor foi limitado ao teto salarial"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante, o valor de ambos salários foram somados"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.value)}}
                  </th>
                  <th>
                    <span
                      v-if="row && row.warnings && row.warnings.includes('MAX_SALARY')"
                      v-b-tooltip.hover
                      title="Valor limitado ao teto previdenciário"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && row.warnings.includes('MIN_SALARY')"
                      v-b-tooltip.hover
                      title="Valor ajustado ao piso (salário mínimo)"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.usedValue != null ? row.usedValue : row.value)}}
                  </th>
                  <th>
                    {{row.update}}
                  </th>
                  <th>
                    {{formatMoney(row.updatedValue)}}
                  </th>
                </tr>
              </tbody>
              </table>
            </DualScroll>
          </div>
        </div>
        <div class="col-md-12 my-2" v-if="benefitLogs.greatestSalaries">
          <button class="btn btn-primary" v-on:click="showGreatestSalaries = !showGreatestSalaries">
            {{ showGreatestSalaries ? 'Esconder' : 'Ver' }} {{ `${benefitLogs.greatestSalariesPercentage * 100}%` }} dos Maiores Salários Desde Julho de 94
          </button>
          <button class="btn btn-primary mx-2" v-on:click="exportToXLSX(benefitLogs.greatestSalaries)">
            Exportar Salários
          </button>
          <div v-if="showGreatestSalaries">
            <DualScroll class="mt-2">
              <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-nowrap">Mês</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor</th>
                  <th class="text-nowrap" style="min-width: 150px">Valor Utilizado</th>
                  <th class="text-nowrap">Indice de Atualização</th>
                  <th class="text-nowrap">Remuneração Atualizada</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in benefitLogs.greatestSalaries"
                  v-bind:key="index"
                >
                  <th>
                    {{row.month}}/{{row.year}}
                  </th>
                  <th>
                    <span
                      v-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY') && row.warnings.includes('MAX_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante e limite salarial, o valor de ambos salários foram somados e o valor foi limitado ao teto salarial"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && (row.warnings.includes('CONCOMITANT_SALARY'))"
                      v-b-tooltip.hover
                      title="Salário concomitante, o valor de ambos salários foram somados"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.value)}}
                  </th>
                  <th>
                    <span
                      v-if="row && row.warnings && row.warnings.includes('MAX_SALARY')"
                      v-b-tooltip.hover
                      title="Valor limitado ao teto previdenciário"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span
                      v-else-if="row && row.warnings && row.warnings.includes('MIN_SALARY')"
                      v-b-tooltip.hover
                      title="Valor ajustado ao piso (salário mínimo)"
                      class="text-warning mr-1"
                    >
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{formatMoney(row.usedValue != null ? row.usedValue : row.value)}}
                  </th>
                  <th>
                    {{row.update}}
                  </th>
                  <th>
                    {{formatMoney(row.updatedValue)}}
                  </th>
                </tr>
              </tbody>
              </table>
            </DualScroll>
          </div>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.lastSalary">
          <h5>Ultimo Salário:</h5>
          <p>{{ benefitLogs.lastSalary.month }}/{{ benefitLogs.lastSalary.year }} - {{ formatMoney(benefitLogs.lastSalary.updatedValue )}}</p>
        </div>

        <div class="col-md-12 my-1" v-if="benefitLogs.value">
          <h5>Valor Total:</h5>
          <p>{{ formatMoney(benefitLogs.value) }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.count">
          <h5>Quantidade de Salários:</h5>
          <p v-if="benefitLogs.minDivisor">{{ benefitLogs.minDivisor }} (Divisor Mínimo)</p>
          <p v-else>{{ benefitLogs.count }}</p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.timeBreakdown && benefitLogs.timeBreakdown.pre94Label && !(benefitLogs.discard && benefitLogs.discard.remainingTimeLabel)">
          <h5>Tempo de contribuição considerado:</h5>
          <p class="font-weight-bold text-info mb-0">
            {{ benefitLogs.timeBreakdown.totalLabel }}
          </p>
          <p class="mb-0">
            = {{ benefitLogs.timeBreakdown.post94Label }} desde 07/1994<span v-if="benefitLogs.count"> ({{ benefitLogs.count }} salários)</span> + <strong>{{ benefitLogs.timeBreakdown.pre94Label }} anteriores a 07/1994*</strong>
          </p>
          <p class="small text-gray-600">
            * O tempo anterior a 07/1994 conta para os requisitos da regra, mas não entra na média de salários (Lei 9.876/99) — por isso a quantidade de salários é menor que o tempo total.
          </p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.discard && benefitLogs.discard.remainingTimeLabel">
          <h5>Tempo de contribuição considerado após o descarte:</h5>
          <p class="font-weight-bold text-info mb-0">
            {{ benefitLogs.discard.remainingTimeLabel }}<span v-if="benefitLogs.discard.requiredTimeLabel"> (mínimo da regra: {{ benefitLogs.discard.requiredTimeLabel }})</span>
          </p>
          <p class="mb-0" v-if="benefitLogs.discard.pre94Label">
            = {{ benefitLogs.discard.post94Label }} desde 07/1994<span v-if="benefitLogs.count"> ({{ benefitLogs.count }} salários mantidos)</span> + <strong>{{ benefitLogs.discard.pre94Label }} anteriores a 07/1994*</strong>
          </p>
          <p class="small text-gray-600" v-if="benefitLogs.discard.pre94Label">
            * O tempo anterior a 07/1994 conta para o mínimo da regra, mas não entra na média de salários (Lei 9.876/99) — por isso a quantidade de salários é menor que o tempo total.
          </p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.baseContribution">
          <h5>Valor Base<span v-if="benefitLogs.name === 'Ultima remuneração proporcional ao tempo de contribuição'"> (Valor Ultimo Salario)</span><span v-else> (Valor Total / Quantidade de Salários)</span>:</h5>
          <p>{{ formatMoney(benefitLogs.baseContribution) }}</p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.factor">
          <h5>Fator:</h5>
          <p>{{ benefitLogs.factor }}</p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.gender">
          <h5>Gênero:</h5>
          <p>{{ benefitLogs.gender }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.baseDivisor">
          <h5>Divisor:</h5>
          <p>{{ benefitLogs.baseDivisor }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.baseDivisorInDays">
          <h5>Divisor em Dias:</h5>
          <p>{{ benefitLogs.baseDivisorInDays }}</p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.contributionYears">
          <h5>Anos de Contribuição:</h5>
          <p>{{ benefitLogs.contributionYears }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.contributionMonths">
          <h5>Meses de Contribuição:</h5>
          <p>{{ benefitLogs.contributionMonths }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.contributionDays">
          <h5>Dias de Contribuição:</h5>
          <p>{{ benefitLogs.contributionDays }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.contributionInDays">
          <h5>Contribuição em Dias: (Dias + Meses * 30 + Anos * 365)</h5>
          <p>{{ benefitLogs.contributionInDays }}</p>
        </div>
        
        <div class="col-md-12 mb-1" v-if="benefitLogs.TC20">
          <h5>Tempo de Contribuição / 20 (TC/20):</h5>
          <p>{{ benefitLogs.TC20 }}</p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.initialPercentage">
          <h5>Porcentagem Inicial:</h5>
          <p>{{ `${benefitLogs.initialPercentage}%` }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.extraPercentage">
          <h5>Porcentagem Extra:</h5>
          <p>{{ `${benefitLogs.extraPercentage > 0 ? benefitLogs.extraPercentage : 0}%` }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.percentage">
          <h5>Porcentagem:</h5>
          <p>{{ `${formatCoefficient(benefitLogs.percentage)}%` }}</p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.reductorPercentage">
          <h5>Porcentagem do Redutor:</h5>
          <p>{{ `${benefitLogs.reductorPercentage * 100}%` }}</p>
        </div>
        
        <div class="col-md-12 mb-1" v-if="benefitLogs.retiredDate">
          <h5>Data da Aposentadoria:</h5>
          <p>{{ benefitLogs.retiredDate }}</p>
        </div>
        <div class="col-md-12 mb-1" v-if="benefitLogs.retiredAge">
          <h5>Anos na Aposentadoria:</h5>
          <p>{{ benefitLogs.retiredAge }}</p>
        </div>

        <div class="col-md-12 mb-1" v-if="benefitLogs.necessaryAge">
          <h5>Idade Necessária:</h5>
          <p>{{ necessaryAgeDisplay }}</p>
        </div>
        
        <div class="col-md-12 mb-1" v-if="benefitLogs.extraYears">
          <h5>Anos Extras:</h5>
          <p>{{ benefitLogs.extraYears > 0 ? benefitLogs.extraYears : 0 }}</p>
        </div>
        
        <div class="col-md-12 mb-1" v-if="!isLoading">
          <h5>Valor Final:</h5>
          <p>{{ formatMoney(benefitLogs.contribution) }} {{ benefitLogs.limitMaxSalary ? ' (Limitado ao Teto Salarial)' : '' }}</p>
        </div>

        <div class="col-md-12 mb-1" v-if="explanations[benefitLogs.name]">
          <h5>Lógica Usada:</h5>
          <p v-for="line of explanations[benefitLogs.name]" :key="line">- {{ line }}</p>
        </div>
      </div>
    </template>

    <template #modal-footer="{ cancel }">
      <!-- <b-button
        variant="outline-primary"
        @click="exportToPDF()"
      >
        Exportar
      </b-button> -->
      <b-button
        variant="outline-primary"
        @click="cancel()"
      >
        Fechar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getRuleBenefit } from '../services/calculations';
import { mergeDisplayAgeFields } from '../utils/benefitLogsDisplayMerge';
import { buildSimulationExportSheetData } from '../utils/simulationExportRows';
import DualScroll from './DualScroll.vue';

export default {
  name: 'RuleBenefitReportModal',

  components: {
    DualScroll,
  },

  props: {
    rule: {
      type: Object,
      required: true,
    },
    isFuture: {
      type: Boolean,
      default: false,
    },
    retiredDate: {
      type: String,
      default: null,
    },
    selectedFutureSalaryType: {
      type: String,
      default: null,
    },
    regimeType: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    isLoading: false,
    isSaving: false,
    modalShow: true,
    showJul94Salaries: false,
    showJul94SalariesSorted: false,
    showGreatestSalaries: false,
    showSalaries: false,
    showRemovedSalaries: false,
    showFullAutoDiscartSimulation: false,
    explanations: {
      'Ultima Remuneração': [
        'Buscar Todos Salários',
        'Buscar Último Salário',
        'Valor Final = Último Salário'
      ],

      'Ultima remuneração proporcional ao tempo de contribuição': [
        'Buscar Todos Salários',
        'Buscar Último Salário',
        'Valor Base = Último Salário',
        'Divisor = 35 (para Homem) ou Divisor = 30 (para Mulher)',
        'Divisor em Dias = Divisor * 365',
        'Contribuição Total em Dias = Dias de Contribuição + (Meses de Contribução * 30) + (Anos de Contribuição * 365)',
        'Valor Final = Valor Base * (Contribuição Total em Dias / Divisor em Dias)'
      ],

      'Última remuneração proporcional ao tempo de contribuição divisor 40': [
        'Buscar Todos Salários',
        'Buscar Último Salário',
        'Valor Base = Último Salário',
        'Divisor = 40',
        'Divisor em Dias = Divisor * 365',
        'Contribuição Total em Dias = Dias de Contribuição + (Meses de Contribução * 30) + (Anos de Contribuição * 365)',
        'Valor Final = Valor Base * (Contribuição Total em Dias / Divisor em Dias)'
      ],

      'Última remuneração proporcional ao tempo de contribuição divisor 35': [
        'Buscar Todos Salários',
        'Buscar Último Salário',
        'Valor Base = Último Salário',
        'Divisor = 35',
        'Divisor em Dias = Divisor * 365',
        'Contribuição Total em Dias = Dias de Contribuição + (Meses de Contribução * 30) + (Anos de Contribuição * 365)',
        'Valor Final = Valor Base * (Contribuição Total em Dias / Divisor em Dias)'
      ],

      'MÉDIA DE TODAS AS CONTRIBUIÇÕES DESDE JULHO/1994': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Final = Valor Total / Quantidade de Salários'
      ],

      'MÉDIA DE TODAS AS CONTRIBUIÇÕES DESDE JULHO/1994 * FATOR PREVIDENCIÁRIO': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Valor Final = Valor Base * Fator Previdenciário'
      ],

      'Média de todas as contribuições desde Julho/1994': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Final = Valor Total / Quantidade de Salários'
      ],

      'MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Final = Valor Total / Quantidade de Salários'
      ],

      'MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94 * FATOR PREVIDENCIÁRIO': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Valor Final = Valor Base * Fator Previdenciário'
      ],

      'MÉDIA DE X% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'X% = (80% antes de 2022) ou (85% de 2022 a 2024) ou (90% depois de 2024)',
        'Filtrar X% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Final = Valor Total / Quantidade de Salários'
      ],

      'MÉDIA DE 90% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Final = Valor Total / Quantidade de Salários'
      ],

      'Média de 80% das maiores contribuições desde Julho/94': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Final = Valor Total / Quantidade de Salários'
      ],

      'MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94 + proporcional ao tempo de contribuição': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Divisor = 35 (para Homem) ou Divisor = 30 (para Mulher)',
        'Divisor em Dias = Divisor * 365',
        'Contribuição Total em Dias = Dias de Contribuição + (Meses de Contribução * 30) + (Anos de Contribuição * 365)',
        'Valor Final = Valor Base * (Contribuição Total em Dias / Divisor em Dias)'
      ],

      'Média de 80% das maiores contribuições desde Julho/94 + Proporcional ao tempo de contribuição': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Divisor = 35 (para Homem) ou Divisor = 30 (para Mulher)',
        'Divisor em Dias = Divisor * 365',
        'Contribuição Total em Dias = Dias de Contribuição + (Meses de Contribução * 30) + (Anos de Contribuição * 365)',
        'Valor Final = Valor Base * (Contribuição Total em Dias / Divisor em Dias)'
      ],

      'TC/20 com resultado limitado a 1 * (60% DA MÉDIA DE TODOS AS CONTRIBUIÇÕES DESDE JULHO DE 1994 + 2% POR CADA ANO QUE EXCEDER 20)': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Valor Final * TC/20',      
      ],

      'TC/20 com resultado limitado a 1 * (60% da média de 80% maiores contribuições desde Julho de 1994 + 1% por cada ano que exceder 20 limitado a 100%)': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 1% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Se Porcentagem > 1: Porcentagem = 1',
        'Valor Final = Valor Base * Porcentagem',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Valor Final * TC/20',      
      ],

      'TC/20 com resultado limitado a 1 * (60% da média de 100% maiores contribuições desde Julho de 1994 + 1% por cada ano que exceder 20 limitado a 100%)': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 100% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 1% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Se Porcentagem > 1: Porcentagem = 1',
        'Valor Final = Valor Base * Porcentagem',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Valor Final * TC/20',      
      ],

      'TC/20 com resultado limitado a 1 * (60% da média das 90% maiores contribuições desde Julho de 1994 + 2% por cada ano que exceder 20': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 90% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Valor Final * TC/20',      
      ],

      'TC/20 com resultado limitado a 1 * (MÉDIA DAS 80% MAIORES CONTRIBUIÇÕES DESDE JULHO DE 1994)': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Média = Valor Total / Quantidade de Salários',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Média * TC/20',
        'Limite = Média das 80% Maiores Contribuições',
        'Se Valor Final > Limite: Valor Final = Limite',
      ],

      'TC/20 com resultado limitado a 1 * (última remuneração)': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Valor Final * TC/20',      
      ],

      'TC/20 com resultado limitado a 1 * (60% da média de todos as contribuições desde Julho de 1994 + 2% por cada ano que exceder 20)': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Valor Final * TC/20',      
      ],

      'MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94 + REDUTOR': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem do Redutor = 3.5% (Se aposentou antes de 31/12/2005) ou Porcentagem do Redutor = 5% (Se aposentou depois de 31/12/2005)',
        'Idade de Aposentadoria = Idade quando possivel Aposentadoria',
        'Idade Necessária = Idade Necessária para Regra',
        'Idade Extra = Idade de Aposentadoria - Idade Necessária',
        'Valor Final = Valor Base',
        'Se Idade Extra > 0: Valor Final = Valor Final - (Valor Final * Porcentagem do Redutor * Idade Extra)'
      ],

      'Média de 80% das maiores contribuições desde Julho/94 + Redutor': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem do Redutor = 3.5% (Se aposentou antes de 31/12/2005) ou Porcentagem do Redutor = 5% (Se aposentou depois de 31/12/2005)',
        'Idade de Aposentadoria = Idade quando possivel Aposentadoria',
        'Idade Necessária = Idade Necessária para Regra',
        'Idade Extra = Idade de Aposentadoria - Idade Necessária',
        'Valor Final = Valor Base',
        'Se Idade Extra > 0: Valor Final = Valor Final - (Valor Final * Porcentagem do Redutor * Idade Extra)'
      ],

      '60% DA MÉDIA DE TODOS AS CONTRIBUIÇÕES DESDE JULHO DE 1994 + 2% POR CADA ANO QUE EXCEDER 20': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],
      
      'TC/20 com resultado limitado a 1 * (60% da média das 80% maiores contribuições desde Julho de 1994 + 2% por cada ano que exceder 20)': [
        'Buscar 80% dos Maiores Salários desde Julho/1994',
        'Valor Total = Soma de 80% dos Maiores Salários',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Valor Final * TC/20',     
      ],

      '60% DA MÉDIA DE TODOS AS CONTRIBUIÇÕES DESDE JULHO DE 1994 + 2% POR CADA ANO QUE EXCEDER 15': [
        'Buscar Todos Salários desde Julho/1994', 
        'Valor Total = Soma de Todos Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 15',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% da média de todos as contribuições desde Julho de 1994 + 2% por cada ano que exceder 15': [
        'Buscar Todos Salários desde Julho/1994', 
        'Valor Total = Soma de Todos Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 15',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% da média de todos as contribuições desde Julho de 1994 + 2% por cada ano que exceder 20': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '70% da MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94 + 1% para cada grupo de 12 contribuições': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 70%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '70% da Média de 80% das maiores contribuições desde Julho/94 + 1% para cada grupo de 12 contribuições': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 70%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '70% da MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94 + 1% para cada grupo de 12 contribuições (limitado a 100%)': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 70%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem (limitado a 100%)'
      ],

      '70% da Média de 80% das maiores contribuições desde Julho/94 + 1% para cada grupo de 12 contribuições (limitado a 100%)': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 70%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem (limitado a 100%)'
      ],

      '60% da MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94 + 1% para cada grupo de 12 contribuições': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% da média das 90% maiores contribuições desde Julho de 1994 + 2% por cada ano que exceder 20': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 90% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 60%',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Extra = 2% * Anos Extras',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% da média das 90% maiores contribuições desde Julho de 1994 + 2% por cada ano que exceder 15': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 90% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 60%',
        'Anos Extras = Anos de Contribuição - 15',
        'Porcentagem Extra = 2% * Anos Extras',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% da MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94 + 1% PARA CADA ANO COMPLETO ( LIMITADO A 100% )': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra (limitado a 100%)',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% da Média de 80% das maiores contribuições desde Julho/94 + 1% para cada ano completo (limitado a 100%)': [
        'Buscar Todos Salários desde Julho/1994',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra (limitado a 100%)',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% DA MÉDIA DE TODOS AS CONTRIBUIÇÕES DESDE JULHO DE 1994 + 1% PARA CADA ANO COMPLETO': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Todos Salários desde Julho/1994',
        'Quantidade de Salários = Quantidade de Salários desde Julho/1994',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% da média de todos as contribuições desde Julho de 1994 + 1% para cada ano completo': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Todos Salários desde Julho/1994',
        'Quantidade de Salários = Quantidade de Salários desde Julho/1994',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '60% DA MÉDIA DE TODOS AS CONTRIBUIÇÕES DESDE JULHO DE 1994 + 1% PARA CADA ANO COMPLETO (LIMITADO A 100%)': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Todos Salários desde Julho/1994',
        'Quantidade de Salários = Quantidade de Salários desde Julho/1994',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 1% * Anos de Contribuição (limitado a 100%)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],
      
    '70% da última remuneração + 1% da última remuneração por grupo de 12 contribuições (até o limite de 30%)': [
        'Buscar Último Salário',
        'Base de Cálculo = 70% do Valor da última remuneração',
        'Calcular tempo de contribuição',
        'Dividir tempo de contribuição em grupos de 12 meses (anos)',
        'Calcular acréscimo de 1% por grupo (máximo de 30%)',
        'Somar o acréscimo à base de cálculo',
        'Resultado final = Base de Cálculo + Acréscimo percentual'
      ],

    '70% DA MÉDIA DE TODOS AS CONTRIBUIÇÕES DESDE JULHO DE 1994 + 2% POR CADA ANO QUE EXCEDER 20': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 70%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],
      
    '70% DA MÉDIA DE TODAS AS CONTRIBUIÇÕES DESDE JULHO DE 1994 + 1% PARA CADA GRUPO DE 12 CONTRIBUIÇÕES': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 70%',
        'Porcentagem Extra = 1% * Anos de contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem'
      ],

      '70% DA MÉDIA DE TODAS AS CONTRIBUIÇÕES DESDE JULHO DE 1994 + 1% PARA CADA GRUPO DE 12 CONTRIBUIÇÕES (LIMITADO A 100%)': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 70%',
        'Porcentagem Extra = 1% * Anos de contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem (limitado a 100%)'
      ],

      '70% da (MÉDIA DE 80% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94 * FATOR PREVIDENCIÁRIO) + 5% a cada ano que superar o total exigido (tempo + pedágio) até o limite de 100%': [
        'Buscar Todos Salários desde Julho/1994',
        'Ordernar Salários do Maior para o Menor',
        'Filtrar 80% dos Maiores Salários',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Base = (Valor Total / Quantidade de Salários) * Fator Previdenciário',
        'Anos Extras = Anos de Contribuição - Necessário (tempo + pedágio)',
        'Porcentagem Extra = 5% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra (limitado a 100%)',
        'Valor Final = Valor Base * Porcentagem'
      ],

      'MÉDIA DE 100% DAS MAIORES CONTRIBUIÇÕES DESDE JULHO/94': [
        'Buscar Todos Salários desde Julho/1994',
        'Valor Total = Soma de Todos Salários Filtrados',
        'Quantidade de Salários = Quantidade de Salários Filtrados',
        'Valor Final = Valor Total * Quantidade de Salários'
      ],

      'TC/20 com resultado limitado a 1 * (60% da média das X% maiores contribuições desde Julho de 1994 + 2% por cada ano que exceder 20)': [
        'Buscar X% dos Maiores Salários desde Julho/1994',
        'X = (80 antes de 2022) ou (85 de 2022 a 2024) ou (90 depois de 2024)',
        'Valor Total = Soma de X% dos Maiores Salários',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem',
        'TC/20 = Anos de Contribuição / 20',
        'Se TC/20 < 1: Valor Final = Valor Final * TC/20',   
      ],

      '60% da média das X% maiores contribuições desde Julho/94 + 2% por cada ano que exceder 20': [
        'Buscar X% dos Maiores Salários desde Julho/1994',
        'X% = 80%, nos anos de 2021 e 2022; 85% nos anos de 2023 e 2024; e 90% no ano de 2025 e seguintes',
        'Valor Total = Soma de X% dos Maiores Salários',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Anos Extras = Anos de Contribuição - 20',
        'Porcentagem Inicial = 60%',
        'Porcentagem Extra = 2% * Anos Extras (para Anos Extras maior que 0)',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem',
      ],

      '60% da média das X% maiores contribuições desde Julho de 1994 + 2% por cada ano que exceder 20': [

      ],

      '70% da média das X% maiores contribuições desde Julho/94 + 1% por ano contribuído': [
        'Buscar X% dos Maiores Salários desde Julho/1994',
        'X% = (80% antes de 2022) ou (85% de 2022 a 2024) ou (90% depois de 2024)',
        'Valor Total = Soma de X% dos Maiores Salários',
        'Quantidade de Salários = Quantidade de Salários',
        'Valor Base = Valor Total / Quantidade de Salários',
        'Porcentagem Inicial = 70%',
        'Porcentagem Extra = 1% * Anos de Contribuição',
        'Porcentagem = Porcentagem Inicial + Porcentagem Extra',
        'Valor Final = Valor Base * Porcentagem',
      ],
    }
  }),

  created() {
    this.fetchBenefitIfNeeded();
  },

  computed: {
    benefitLogs() {
      return (this.rule && this.rule.benefitLogs) ? this.rule.benefitLogs : {};
    },
    hasFullAutoDiscartSimulation() {
      if (this.benefitLogs?.fullAutoDiscartSimulation?.removedSalaries?.length === 1 ){
        return false
      }
      return !!(this.benefitLogs?.fullAutoDiscartSimulation?.removedSalaries?.length);
    },
    // #516 P1-1 (stop-gate Codex, rodada 2): fonte canônica é benefitLogs.display*
    // — sempre presente no fluxo novo (enrichDisplayAge grava isso incondicionalmente,
    // inclusive 0 quando não há idade). O ramo "legado" só existe pra logs SALVOS
    // ANTES do #516, que nunca tiveram display* persistido; é isolado e explícito
    // aqui, nunca um fallback silencioso decidindo no fluxo novo.
    necessaryAgeDisplay() {
      const benefitLogs = this.benefitLogs;
      const isLegacyLog = benefitLogs.displayNecessaryAge == null && benefitLogs.necessaryAge != null;

      const years = isLegacyLog ? benefitLogs.necessaryAge : benefitLogs.displayNecessaryAge;
      const months = isLegacyLog ? 0 : (benefitLogs.displayNecessaryAgeMonths || 0);
      const days = isLegacyLog ? 0 : (benefitLogs.displayNecessaryAgeDays || 0);

      let text = `${years} anos`;
      if (months) text += ` e ${months} meses`;
      if (days) text += ` e ${days} dias`;
      return text;
    }
  },

  methods: {
    // Coeficiente vem como fração (ex.: 1.14); multiplicar por 100 em float gera
    // dízima na tela (113.9999…%). Formatter único para as 3 renderizações;
    // null/undefined mantém o fallback 100 (comportamento anterior).
    formatCoefficient(percentage) {
      // #453: mata a dízima de ponto flutuante (113,9999% → 114%) SEM arredondar
      // coeficiente decimal legítimo (70,5% continua 70,5%). Só cola no inteiro quando
      // está a menos de ~0,001 dele; caso contrário preserva o valor, com no máx. 2 casas.
      if (percentage == null) return 100;
      const pct = percentage * 100;
      const nearest = Math.round(pct);
      if (Math.abs(pct - nearest) < 0.005) return nearest;
      return Math.round(pct * 100) / 100;
    },
    async fetchBenefitIfNeeded() {
      try {
        if (this.selectedFutureSalaryType) {
          this.$set(this.rule, 'benefitLogs', null);
        } else if (this.rule.benefitLogs?.name) {
          return;
        }

        this.isLoading = true;
        const calculationId = this.rule?.calculation?.id || this.rule?.calculationId;
        const ruleId = this.rule?.id;
        if (!calculationId || !ruleId) {
          this.isLoading = false;
          return;
        }
        const params = {
          isFuture: this.isFuture,
          retiredDate: this.retiredDate,
          futureSalaryType: this.selectedFutureSalaryType || undefined,
        };

        const body = {
          increased: {
            increasedYears: this.rule.increasedNecessaryContribution || this.rule.increasedNecessaryTeachingTime || this.rule.increasedNecessarySpecialTime || this.rule.increasedNecessaryDisabledTime,
            increasedMonths: this.rule.increasedNecessaryContributionMonths || this.rule.increasedNecessaryTeachingTimeMonths || this.rule.increasedNecessarySpecialTimeMonths || this.rule.increasedNecessaryDisabledTimeMonths,
            increasedDays: this.rule.increasedNecessaryContributionDays || this.rule.increasedNecessaryTeachingTimeDays || this.rule.increasedNecessarySpecialTimeDays || this.rule.increasedNecessaryDisabledTimeDays,
          },
          necessaryPoints: this.rule.necessaryPoints,
        };

        const response = await getRuleBenefit(calculationId, ruleId, params, body);

        if (response && response.logs) {
          if (this.selectedFutureSalaryType) {
            this.$set(this.rule, 'benefitLogsByFutureType', this.rule.benefitLogsByFutureType || {});
            this.$set(this.rule.benefitLogsByFutureType, this.selectedFutureSalaryType, response.logs);
          }
          // #516 rodada 3 (mandato do arbitro): getRuleBenefit nao devolve
          // display*; sem este merge a substituicao abaixo apaga os campos
          // que enrichDisplayAge ja tinha gravado em `this.rule` e o modal
          // volta a cair no ramo isLegacyLog (idade crua). Ver
          // client/src/utils/benefitLogsDisplayMerge.js para o contrato.
          this.rule.benefitLogs = mergeDisplayAgeFields(this.rule, response.logs);
          this.rule.estimatedBenefit = response.estimatedBenefit;
        }
      } catch (e) {
      } finally {
        this.isLoading = false;
      }
    },
    formatMoney(value) {
      if (!value) return "0".toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});

      return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    isBestContribution(value, bestValue) {
      if (bestValue === undefined || bestValue === null) return false;

      const normalizedValue = Number(value);
      const normalizedBest = Number(bestValue);

      if (Number.isNaN(normalizedValue) || Number.isNaN(normalizedBest)) return false;

      return normalizedValue === normalizedBest;
    },

    async exportToPDF() {
      const div = document.getElementById('benefit-report');

      let style = '';

      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        style += node.outerHTML;
      }

      const win = window.open();

      win.document.write(`<style>${style}</style>`);
      win.document.write(div.innerHTML);

      win.document.close();
      win.focus();
      win.print();
      win.close();
    },

    async exportToXLSX(salaries) {
      let wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "Salários",
        Subject: "Salários",
        Author: "GenialPrev",
        CreatedDate: new Date(),
      };

      wb.SheetNames.push("Report Sheet");

      let ws_data = [
        [
          "Mês",
          "Valor",
          "Valor Utilizado",
          "Indice de Atualização",
          "Remuneração Atualizada",
        ],
      ];

      salaries.forEach((salary) => {
        const row = [
          `${salary.month}/${salary.year}`,
          `${this.formatMoney(salary.value)}`,
          `${this.formatMoney(salary.usedValue != null ? salary.usedValue : salary.value)}`,
          `${salary.update}`,
          `${this.formatMoney(salary.updatedValue)}`
        ];

        ws_data.push(row);
      });

      let ws = XLSX.utils.aoa_to_sheet(ws_data);

       wb.Sheets["Report Sheet"] = ws;

      let wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

      let buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf); //create uint8array as viewer

      for (let i = 0; i < wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xff; //convert to octet

      saveAs(
        new Blob([buf], { type: "application/octet-stream" }),
        "Salários.xlsx"
      );
    },

    // #460 (S3-exp, apontamento Ju 11/09): normalizador PRÓPRIO da tabela de
    // "Simulação completa do Descarte Automático". exportToXLSX (acima) lê
    // month/year/value/... direto de cada elemento; aqui cada linha é
    // { salary, benefit, beyondAllowedDiscard?, beyondReason? } (mesmo formato
    // do descarte real), por isso um normalizador separado — exportação das
    // outras tabelas (exportToXLSX) fica intocada. Montagem das linhas
    // extraída para client/src/utils/simulationExportRows.js (função pura,
    // testada em api/tests/unit/simulationExportRows.test.js — achado Codex
    // #539-e6c37cf0) para não haver dois lugares calculando a mesma planilha.
    async exportSimulationToXLSX(rows) {
      let wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "Simulação do Descarte Automático",
        Subject: "Simulação do Descarte Automático",
        Author: "GenialPrev",
        CreatedDate: new Date(),
      };

      wb.SheetNames.push("Report Sheet");

      let ws_data = buildSimulationExportSheetData(rows, {
        formatMoney: this.formatMoney,
        formatCoefficient: this.formatCoefficient,
      });

      let ws = XLSX.utils.aoa_to_sheet(ws_data);

      wb.Sheets["Report Sheet"] = ws;

      let wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

      let buf = new ArrayBuffer(wbout.length);
      let view = new Uint8Array(buf);

      for (let i = 0; i < wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xff;

      saveAs(
        new Blob([buf], { type: "application/octet-stream" }),
        "Simulação Descarte.xlsx"
      );
    }
  }
}
</script>

<style scoped>
:deep(.modal-body) {
  max-height: 80vh;
  overflow-y: auto;
}

#benefit-report table {
  min-width: 100%;
}
</style>
